import VideoComponents from  "./src/components/VideoComponent.vue";
import SlideBar from './src/html_elements/Slidebar.js';
export default VideoComponents;
export {SlideBar};